import webApi from "../WebApi/WebApi";

export const getSchemeMaster = async () => {
    return await webApi.get(`/MIS/impSchemeMaster`,);
}

export const getFinYear = async (lgdCode) => {
    return await webApi.get(`/MonthClose/FinYear?lgdCode=${lgdCode}`);
}

export const getSchemeBalance = async (
    dist,
    block,
    gp,
    scheme,
    report,
    frmDate,
    toDate
) => {
    return await webApi.get(
        `/MIS/SchemeBalance?distLgd=${dist}&blockLgd=${block}&gpLgd=${gp}&schemeId=${scheme}&rptType=${report}&frmDate=${frmDate}&toDate=${toDate}`
    );
};

export const getPriWiseReceiptPayment = async (
    dist,
    block,
    gp,
    report,
    frmDate,
    toDate
) => {
    return await webApi.get(
        `/MIS/priWiseBalance?distLgd=${dist}&blockLgd=${block}&gpLgd=${gp}&rptType=${report}&frmDate=${frmDate}&toDate=${toDate}`
    );
};